import ScopeFiltersForm from './ScopeFiltersForm';

export default ScopeFiltersForm;
